// extracted by mini-css-extract-plugin
module.exports = {"document":"affiliate-terms_document__F0mor"};